import * as React from "react";
import type { SVGProps } from "react";
const SvgHash01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M19.2 15.6H4.8m14.4-7.2H4.8m3.6 10.8V4.8m7.2 14.4V4.8"
    />
  </svg>
);
export default SvgHash01;
